import { useLocation } from "react-router-dom";

/** Gujarati strings for the shared chrome (navbar, footer, badges) on /gu/* routes. */
const GU = {
  // Navbar
  "Home": "હોમ",
  "About": "અમારા વિશે",
  "Psychiatry": "માનસિક રોગ",
  "Neuropsychiatry": "ન્યુરોસાઇકિયાટ્રી",
  "Deaddiction": "વ્યસનમુક્તિ",
  "Neuromodulation": "ન્યુરોમોડ્યુલેશન",
  "Sexology": "જાતીય સ્વાસ્થ્ય",
  "Case Reports": "કેસ રિપોર્ટ",
  "Articles": "લેખ",
  "Blog": "બ્લોગ",
  "FAQ": "પ્રશ્નોત્તર",
  "Contact": "સંપર્ક",
  "Book Appointment": "સમય માંગો",
  "Since 1989": "૧૯૮૯થી",

  // Footer
  "Neuropsychiatry · Since 1989": "ન્યુરોસાઇકિયાટ્રી · ૧૯૮૯થી",
  "A premium psychiatric care facility offering deaddiction services, sex therapy, and interventional neuromodulation. Evidence-based, empathetic, exceptional.":
    "વ્યસનમુક્તિ, જાતીય સ્વાસ્થ્ય અને આધુનિક ન્યુરોમોડ્યુલેશન સારવાર આપતી ભાવનગરની માનસિક આરોગ્ય હોસ્પિટલ. પુરાવા આધારિત સારવાર, સંપૂર્ણ ગુપ્તતા અને માણસાઈભર્યો વ્યવહાર.",
  "Quick Links": "ઝડપી લિંક",
  "Reach Us": "અમારો સંપર્ક",
  "Get directions →": "રસ્તો જુઓ →",
  "All rights reserved.": "સર્વ હક્ક સુરક્ષિત.",
  "Bhavnagar, Gujarat — India": "ભાવનગર, ગુજરાત — ભારત",
  "2nd floor, Carlton Square, Near Madhavdeep Complex,": "બીજો માળ, કાર્લટન સ્ક્વેર, માધવદીપ કોમ્પ્લેક્સ પાસે,",
  "Kalanala, Bhavnagar — 364001": "કાળાનાળા, ભાવનગર — ૩૬૪૦૦૧",

  // Footer quick links
  "About Us": "અમારા વિશે",
  "General Psychiatry": "સામાન્ય માનસિક રોગો",
  "Depression Treatment": "હતાશા (ડિપ્રેશન)",
  "Anxiety & Panic": "ચિંતા અને ગભરામણ",
  "OCD Treatment": "વારંવારના વિચાર (OCD)",
  "Insomnia Treatment": "અનિદ્રા",
  "Bipolar Disorder": "બાયપોલર ડિસઓર્ડર",
  "ADHD in Children": "બાળકોમાં ADHD",
  "Schizophrenia & Psychosis": "સ્કિઝોફ્રેનિયા અને ભ્રમ",
  "Stress & Adjustment": "તણાવ અને માનસિક આઘાત",
  "Body Pain & Headache": "શરીરનો દુખાવો અને માથું",
  "Dementia & Memory Loss": "ડિમેન્શિયા અને યાદશક્તિ",
  "Women's Mental Health": "સ્ત્રીઓનું માનસિક સ્વાસ્થ્ય",
  "Suicide Risk & Crisis Care": "આત્મહત્યાનું જોખમ અને કટોકટી",
  "Epilepsy with Depression": "વાઈ સાથે હતાશા",
  "Post-Stroke Depression": "લકવા પછીની હતાશા",
  "rTMS Treatment": "rTMS સારવાર",
  "Modified Brief Pulse Therapy": "mBPT સારવાર",
  "tDCS Treatment": "tDCS સારવાર",
  "Ketamine IV Infusion": "કેટામીન ઇન્ફ્યુઝન",
  "Naltrexone Implant": "નાલ્ટ્રેક્સોન ઇમ્પ્લાન્ટ",
  "For Physicians": "તબીબો માટે",
  "ગુજરાતીમાં વાંચો": "સામાન્ય માનસિક રોગો (ગુજરાતી)",

  // Badges / floating button
  "Review us on Google": "ગૂગલ પર રિવ્યૂ આપો",
  "on Google": "ગૂગલ પર",
  "Emergency": "ઇમરજન્સી",
  "Call Now": "હમણાં ફોન કરો",
};

/** Gujarati equivalents for pages that have their own Gujarati version. */
const GU_ROUTES = {
  "/general-psychiatry": "/gu/general-psychiatry",
  "/neuropsychiatry": "/gu/neuropsychiatry",
  "/deaddiction": "/gu/deaddiction",
  "/neuromodulation": "/gu/neuromodulation",
  "/sexology": "/gu/sexology",
};

export const useChrome = () => {
  const { pathname } = useLocation();
  const isGu = pathname === "/gu" || pathname.startsWith("/gu/");
  return {
    isGu,
    g: (s) => (isGu && GU[s]) || s,
    route: (to) => (isGu && GU_ROUTES[to]) || to,
    reviewCountLabel: (n) => (isGu ? `${n} ગૂગલ રિવ્યૂ` : `${n} Google reviews`),
  };
};

export default useChrome;
